// ===================================================
// @gam/editor — public API
// ===================================================
//
// Phase 1B exports (framework-pure pieces).
// Phase 1C will add: TiptapEditor, FloatingToolbar (after DI refactor).

// Types
export type * from "./types";

// UI primitives (framework-pure)
export { BlockHandle } from "./BlockHandle";
export { ColorMenu } from "./ColorMenu";
export { FloatingToolbar } from "./FloatingToolbar";
export { SlashCommandMenu } from "./SlashCommandMenu";
export { SlashQuickBar } from "./SlashQuickBar";
export { SlashFullMenu } from "./SlashFullMenu";
export { iconForCommand, SLASH_COMMAND_ICONS } from "./slash-command-icons";
export { EditorOverlay, EditorOverlayProvider, EDITOR_OVERLAY_Z } from "./editor-overlay";

// Font picker registry — add a language group here, nothing else changes.
export { EDITOR_FONT_GROUPS, ALL_EDITOR_FONTS } from "./fonts";
export type { EditorFont, EditorFontGroup } from "./fonts";
export { DEFAULT_FAVOURITES, PANEL_RECENTS, readRecents, pushRecent, quickBarTitles } from "./slash-recents";

// Custom order for the תוספים panel — families and the plugins inside them.
// localStorage only; a display preference, never shared data.
export {
  EMPTY_SLASH_ORDER,
  readSlashOrder,
  writeSlashOrder,
  resetSlashOrder,
  orderCategories,
  orderItems,
  moveCategory,
  moveItem,
} from "./slash-order";
export type { SlashOrder } from "./slash-order";

// Slash command catalog
export {
  slashCommandItems,
  slashCommandCategories,
} from "./slash-command-items";

// Extensions
export { CalloutBlock } from "./extensions/CalloutBlock";
export { CodeBlockGam } from "./extensions/CodeBlockGam";
export { EmbedBlock } from "./extensions/EmbedBlock";
export { FieldBlock } from "./extensions/FieldBlock";
export { FileBlock } from "./extensions/FileBlock";
export { ImageBlock } from "./extensions/ImageBlock";
export { ObjectRef } from "./extensions/ObjectRef";
export { objectRefUrl } from "./extensions/object-ref-url";
export type { ObjectRefTarget } from "./extensions/object-ref-url";
export {
  SlashCommands,
  GAM_SLASH_MENU_EVENT,
  GAM_SLASH_DISMISS_EVENT,
  dispatchSlashDismiss,
} from "./extensions/SlashCommands";
export type { GamSlashMenuEventDetail } from "./extensions/SlashCommands";
export { tableExtensions } from "./extensions/TableSetup";
export {
  ToggleDetails,
  DetailsSummary,
  DetailsContent,
} from "./extensions/Toggle";

// Extension tiers — how much editor a surface gets, and the HTML bridge for
// surfaces that already persist an HTML string instead of Tiptap JSON.
export { CHROME_BY_TIER, buildLeanExtensions } from "./editor-tiers";
export type { EditorTier, EditorChrome } from "./editor-tiers";
export { htmlToDoc, docToHtml, normalizeLegacyStickyHtml } from "./editor-html";

// i18n defaults + type
export { DEFAULT_EDITOR_TRANSLATIONS } from "./editor-translations";
export type { EditorTranslations } from "./editor-translations";

// Version marker (helpful for ensuring consumers picked up the right build)
export const VERSION = "0.1.0";

// Framework-pure TiptapEditor (Phase 1C — translations + gibberish injected)
export { TiptapEditor } from "./TiptapEditor";
